import { useState, useEffect } from 'react';
import ScreenProperties from '../types/screenProperties';

const getWindowWidth = (): ScreenProperties => {
    const { innerWidth: width } = window;
    let screen: string = 'Phone';
    if (width > 1024) {
        screen = 'Desktop';
    }
    if (width <= 1024 && width >= 768) {
        screen = 'Tablet';
    }
    if (width < 768) {
        screen = 'Phone';
    }
    return { screen, width };
};

export default function useWindowWidth() {
    const [windowSize, setWindowDimensions] = useState(getWindowWidth());

    useEffect(() => {
        const handleResize = () => {
            setWindowDimensions(getWindowWidth());
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowSize;
}
